import type { BigCategory, SmallCategory } from '@pc/components/Works/Panel/types'
import ModalList from '../shared/ModalList'
import BigOccupationItem from './BigOccupationItem'

interface PropsType {
  selectedJobIds: string[]
  changeJobIds: (arg: string[]) => void
  bigCategories: BigCategory[]
  mappedSmallCategories: Record<string, SmallCategory[]>
}

const BigOccupationList = (props: PropsType) => {
  const { selectedJobIds, changeJobIds, bigCategories, mappedSmallCategories } = props
  const Items = bigCategories.map((bigCategory) => {
    const smallCategories = mappedSmallCategories[bigCategory.attributes.code]

    return (
      <BigOccupationItem
        key={bigCategory.id}
        bigCategory={bigCategory}
        smallCategories={smallCategories}
        selectedJobIds={selectedJobIds}
        changeJobIds={changeJobIds}
      />
    )
  })

  return <ModalList>{Items}</ModalList>
}

export default BigOccupationList
